import http from '@/utils/http'
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

// 名师分类列表
export function getTypeTList(params){
    return http.get('/group/mstype/portal/list',params)
}

// 名师学段列表
export function getClassList(params){
    return http.get('/group/stage/portal/list',params)
}

// 名师工作室列表
export function getTeacherList(data,pageNum,pageSize){
    return http.post('/group/info/list?pageNum='+pageNum+'&pageSize='+pageSize, data)
}

// 名师工作室增加访问量
export function setTeacherNum(id){
    return http.get('/group/info/addMsFwl/'+id)
}

// 教师列表管理中心
export function listTeacher(params){
    return http.get('/teacher/teacher/getTeacherSelectListByAuthority',params)
}




// WEBPACK FOOTER //
// ./src/api/teacher.js